// extracted by mini-css-extract-plugin
export default {"zoomModal":"Y0-z","image":"Z0-z","button":"_0-z","isOverlayShown":"a1-z"};